import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import NotificationRuleCopyForm from './NotificationRuleCopyForm'
import { copyNotificationRuleAction } from '@/redux/order/serviceNotificationSlice'

function pickErrorMessage (err) {
  if (typeof err === 'string') return err
  if (err && typeof err === 'object') {
    if (typeof err.message === 'string') return err.message
    if (typeof err.msg === 'string') return err.msg
  }
  return '拷贝失败'
}

function NotificationRuleCopyModalInner (props) {
  const dispatch = useDispatch()
  const { children, baseProps, width = 480 } = props
  const bp = baseProps || {}
  const { ruleId, onSuccess } = bp

  const handleOk = async (form) => {
    if (ruleId == null || ruleId === '') {
      throw new Error('缺少规则 id')
    }
    const fields = await form.current.validateFields()
    const rawIds = fields.targetStoreIds
    const idList = Array.isArray(rawIds) ? rawIds : rawIds != null && rawIds !== '' ? [rawIds] : []
    const targetStoreIds = idList
      .map((id) => Number(id))
      .filter((n) => Number.isFinite(n))
    if (targetStoreIds.length === 0) {
      throw new Error('请选择至少一个目标门店')
    }
    try {
      await dispatch(
        copyNotificationRuleAction({
          id: ruleId,
          targetStoreIds,
          overwrite: fields.overwrite === true
        })
      ).unwrap()
      message.success('拷贝成功')
      if (typeof onSuccess === 'function') onSuccess()
    } catch (err) {
      message.error(pickErrorMessage(err))
      throw err
    }
  }

  const title = bp.ruleName ? `拷贝到其他店铺 · ${bp.ruleName}` : '拷贝到其他店铺'

  return (
    <WrappedModal
      children={children}
      baseProps={{ ...baseProps }}
      baseComponent={<NotificationRuleCopyForm baseProps={bp} />}
      title={title}
      width={width}
      okText="确认拷贝"
      onOk={handleOk}
    />
  )
}

NotificationRuleCopyModalInner.propTypes = {
  baseProps: PropTypes.object,
  width: PropTypes.number,
  children: PropTypes.node
}

function NotificationRuleCopyModal (props) {
  return <NotificationRuleCopyModalInner {...props} />
}

export default NotificationRuleCopyModal
